var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('BaseScreenHeader',{attrs:{"title":"Muscle Details","screenInfo":"MSP-002","showBack":true,"showNav":true}}),(_vm.loaded)?_c('v-card',{staticClass:"transparent px-0 mt-2",attrs:{"tile":"","flat":""}},[_c('MuscleDisplay',{attrs:{"code":_vm.$route.params.code,"exercises":_vm.exercises}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }